<template>
  <paginated-panel
    :paginator="paginator"
    action="dashboard/getPaginator"
    :loading="$store.state.dashboard.loading"
    :plural-name="i18n.project.filters.projects"
  >
    <template v-slot:header>
      <header class="flex justify-between flex-wrap items-center py-2">
        <h2 class="text-xl flex-1 whitespace-no-wrap" v-text="i18n.title"></h2>
        <current-filters
          :i18n="{ ...i18n.project.filters, ...i18n.project.status }"
          class="flex-1 text-sm mx-2"
          v-if="$store.state.account.projectsCount > 10"
        />
        <div
          class="flex text-xl items-center text-gray-700 relative"
          v-if="$store.state.account.projectsCount > 0"
        >
          <form class="w-42 flex" @submit.prevent="reload">
            <input
              type="search"
              v-model="paginatorFilters.search"
              :placeholder="i18n.project.search.placeholder"
              minlength="3"
              :class="paginatorFilters.search ? 'rounded-r-none' : ''"
            />
            <button
              type="submit"
              v-tooltip="i18n.project.search.tooltip"
              class="rounded-r px-2 text-sm"
              :class="
                paginatorFilters.search
                  ? 'bg-gray-700 text-white'
                  : 'text-transparent'
              "
            >
              <font-awesome-icon icon="search" />
            </button>
          </form>
          <export-projects :endpoint="exportEndpoint" :i18n="i18n.download" />
          <projects-filters
            :i18n="{ ...i18n.project.filters, ...i18n.project.status }"
            @status-filter-updated="updateStatusFilter"
            v-if="$store.state.account.projectsCount > 10"
          />
        </div>
      </header>
    </template>
    <template v-slot:item="{ item }">
      <project :data="item"></project>
    </template>
    <template v-slot:empty>
      <alert
        v-if="hasSomeFilter"
        :message="i18n.no_project_criteria"
        class="pl-5 text-sm"
      />
      <div v-else class="flex justify-between items-center w-full">
        <span
          v-text="$store.state.dashboard.i18n.no_project"
          class="whitespace-pre-line"
        ></span>
        <first-project-button
          :label="$store.state.dashboard.i18n.create_first"
        />
      </div>
    </template>
  </paginated-panel>
</template>

<script>
import Project from "./Project";
import PaginatedPanel from "../Design/PaginatedPanel";
import FirstProjectButton from "../Menu/FirstProjectButton";
import ExportProjects from "../Projects/Export";
import ProjectsFilters from "../Projects/Filters";
import CurrentFilters from "../Projects/CurrentFilters";

export default {
  components: {
    Project,
    PaginatedPanel,
    FirstProjectButton,
    ExportProjects,
    ProjectsFilters,
    CurrentFilters,
  },
  data() {
    let paginatorFilters;
    try {
      paginatorFilters = JSON.parse(
        localStorage.getItem("dashboard_projects_filters")
      );
    } catch (error) {
      // ignore any error
    }
    if (typeof paginatorFilters !== "object" || paginatorFilters === null) {
      paginatorFilters = {
        search: "",
      };
    }

    return {
      paginatorFilters,
    };
  },
  watch: {
    ["paginatorFilters.search"](val) {
      if (!val) {
        this.reload();
      }
    },
  },
  methods: {
    updateStatusFilter(statuses) {
      this.$set(this.paginatorFilters, "statuses", statuses);
      this.reload();
    },
    reload() {
      this.$store.dispatch("dashboard/getPaginator", this.paginatorQueryString);
    },
  },
  computed: {
    paginatorQueryString() {
      const query = Object.keys(this.paginatorFilters)
        .filter((key) => this.paginatorFilters[key])
        .map((key) => key + "=" + this.paginatorFilters[key])
        .join("&");
      return query;
    },
    paginator() {
      return this.$store.state.dashboard.projects.paginator;
    },

    i18n() {
      return this.$store.state.dashboard.i18n;
    },
    hasSomeFilter() {
      return this.paginatorQueryString;
    },
    routes() {
      return this.$store.state.dashboard.projects.routes;
    },
    exportEndpoint() {
      return this.routes.export;
    },
  },

  mounted() {
    this.reload();
  },
};
</script>
